import React from "react";

const BS5_ChecksRadios = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_ChecksRadios Component</h2>
      <p>This is the BS5_ChecksRadios component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_ChecksRadios;
